import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { CategoryCode } from '../Components/WidgetSettingOptions';
import { useSettings } from '../util/useSettings';
import useTranslation from '../../../util/hooks/useTranslation';
import WidgetSettingModal from '../Components/WidgetSettingModal';
import { editWidgetSettings } from '../../../reducers/Dashboards/DashboardEdit';

const ItemDetailStatusSetting = ({ widgetInfo, ...restProps }) => {
    const { config } = widgetInfo;
    const settings = useSettings(config);
    const { settings: customSettings } = config;
    const dispatch = useDispatch();
    const t = useTranslation('ItemDetailStatus');

    const [updatedWidgetInfo, setUpdatedWidgetInfo] = useState({});

    const handleCategoryCodeChange = selectedCategoryCode => {
        setUpdatedWidgetInfo(prevState => {
            return { ...prevState, categoryCode: selectedCategoryCode };
        });
    };

    const handleSubmitClick = data => {
        if (customSettings) {
            dispatch(
                editWidgetSettings({
                    id: widgetInfo.id,
                    settings: { ...customSettings, ...data, ...updatedWidgetInfo },
                }),
            );
        } else {
            dispatch(
                editWidgetSettings({
                    id: widgetInfo.id,
                    settings: { ...data, ...updatedWidgetInfo },
                }),
            );
        }
    };

    const handleCancelClick = () => {
        setUpdatedWidgetInfo({});
    };

    return (
        <WidgetSettingModal
            headerTitle={t('Iot Item Detail Status Setting')}
            widgetInfo={widgetInfo}
            hiddenHeader
            okCallback={handleSubmitClick}
            cancelCallback={handleCancelClick}
            {...restProps}
        >
            <CategoryCode
                value={updatedWidgetInfo.categoryCode ? updatedWidgetInfo.categoryCode : settings.categoryCode}
                onChange={handleCategoryCodeChange}
            />
        </WidgetSettingModal>
    );
};

export default ItemDetailStatusSetting;
